"use client";

import { Atom, Beaker, Box, Cpu, Droplet, Flame, Layers, Shield } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Features() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const materials = [{
    name: "手術設備",
    description: "Precision-engineered instruments designed for optimal performance in complex surgical environments.",
    tensile: "High",
    temp: "Sterile",
    Icon: Layers
  }, {
    name: "診斷設備",
    description: "Advanced imaging and testing equipment providing clinicians with accurate, real-time patient data.",
    tensile: "Reliable",
    temp: "Stable",
    Icon: Droplet
  }, {
    name: "醫學美容",
    description: "Innovative solutions for skin rejuvenation and non-invasive cosmetic procedures for modern clinics.",
    tensile: "Safe",
    temp: "Optimal",
    Icon: Beaker
  }, {
    name: "牙科解決方案",
    description: "Comprehensive dental technology suite supporting restorative and diagnostic workflows.",
    tensile: "Durable",
    temp: "Resistant",
    Icon: Box
  }, {
    name: "人工智能醫療",
    description: "Next-generation artificial intelligence platforms enhancing clinical decision-making and patient outcomes.",
    tensile: "Adaptive",
    temp: "Smart",
    Icon: Atom
  }, {
    name: "數字醫療",
    description: "Connected health ecosystems streamlining patient monitoring and data management across facilities.",
    tensile: "Integrated",
    temp: "Secure",
    Icon: Shield
  }, {
    name: "獸醫設備",
    description: "Specialized medical equipment tailored for the unique physiological needs of veterinary medicine.",
    tensile: "Versatile",
    temp: "Robust",
    Icon: Cpu
  }, {
    name: "通用醫療",
    description: "Essential high-quality medical supplies and devices for daily clinical and hospital operations.",
    tensile: "Standard",
    temp: "Certified",
    Icon: Flame
  }];
  return <section data-section-id="2254" id="keyfeaturesgrid" className="bg-background text-foreground py-20 md:py-28 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 md:px-10 lg:px-16">
        {}
        <div ref={headerRef} className={`grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 mb-16 md:mb-20 transition-all duration-700 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="md:col-span-6">
            <p className="font-default text-xs md:text-sm tracking-[0.2em] uppercase mb-6" style={{
            color: "var(--chart-3)"
          }}>
              我們的專業知識
            </p>
            <h1 className="font-default font-bold text-4xl md:text-5xl lg:text-[56px] leading-[1.05] tracking-tight text-foreground">
              全球醫療採購與配銷
            </h1>
          </div>
          <div className="md:col-span-6 md:pt-4">
            <p className="font-default text-base md:text-lg leading-relaxed text-muted-foreground max-w-xl">
              MS BIOTECHNOLOGY 連結全球創新製造商與醫療專業人員，提供臨床評估、法規支援及策略性分銷，將優質醫療技術推廣至全世界。
            </p>
          </div>
        </div>

        {}
        <div ref={gridRef} className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 transition-all duration-700 ease-out ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          {materials.map((material, i) => {
          const Icon = material.Icon;
          return <div data-index={i} key={material.name} className="group relative rounded-lg border border-border bg-card p-7 md:p-8 transition-all duration-300 ease-out hover:-translate-y-1 shadow-md hover:shadow-lg" style={{
            backgroundColor: "var(--card)"
          }}>
                {}
                <div className="mb-7 inline-flex h-[60px] w-[60px] items-center justify-center rounded-lg transition-colors duration-300" style={{
              backgroundColor: "var(--accent)"
            }}>
                  <Icon className="h-6 w-6 transition-colors duration-300" strokeWidth={1.25} style={{
                color: "var(--chart-3)"
              }} />
                </div>

                {}
                <h3 className="font-default font-semibold text-[24px] leading-tight text-card-foreground mb-3">
                  {material.name}
                </h3>

                {}
                <p className="font-default text-sm leading-relaxed text-muted-foreground mb-8">
                  {material.description}
                </p>

                {}
                <div className="pt-5 border-t border-border">
                  <p className="font-default text-xs tracking-wider uppercase" style={{
                color: "var(--muted-foreground)"
              }}>
                    <span style={{
                  color: "var(--chart-3)"
                }}>QUALITY:</span>{" "}
                    <span className="text-foreground">{material.tensile}</span>
                    <span className="mx-2 opacity-50">·</span>
                    <span style={{
                  color: "var(--chart-3)"
                }}>STATUS:</span>{" "}
                    <span className="text-foreground">{material.temp}</span>
                  </p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}